import CopyIcon from '@mui/icons-material/ContentCopy';
import CopiedIcon from '@mui/icons-material/Done';
import { Box, Grid, IconButton, Stack, useTheme } from '@mui/material';
import Chip from '@mui/material/Chip';
import React, { useState } from 'react';

type ProgressionListChordsRowState = {
  isShowCopied: boolean;
};

export const ProgressionListChordsRow = (props: { chords: string[] }) => {
  const [state, setState] = useState<ProgressionListChordsRowState>({
    isShowCopied: false,
  });

  const handleCopyButtonClick = () => {
    const chordsString = props.chords.join(' ');

    navigator.clipboard.writeText(chordsString).then(() => {
      setState({ ...state, isShowCopied: true });

      setTimeout(() => {
        setState({ ...state, isShowCopied: false });
      }, 3000);
    });
  };

  const theme = useTheme();
  const iconSx = { color: theme.palette.grey['700'], mx: '4px' };

  return (
    <Box
      sx={{
        borderRadius: theme.shape.borderRadius,
        p: 1,
        '&:hover': { background: theme.palette.grey['100'] },
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <Stack
            direction="row"
            spacing={0}
            sx={{
              flexWrap: 'wrap',
            }}
          >
            {props.chords.map((chord, index) => {
              return (
                <Chip
                  className="overwrite-stack-style"
                  key={index}
                  label={chord}
                  sx={{
                    '&.overwrite-stack-style': {
                      my: '3px',
                      mx: '4px',
                    },
                  }}
                />
              );
            })}
          </Stack>
        </Grid>
        <Grid item xs="auto">
          <IconButton onClick={handleCopyButtonClick}>
            {state.isShowCopied ? (
              <CopiedIcon sx={iconSx} />
            ) : (
              <CopyIcon sx={iconSx} />
            )}
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
};
